module.exports = __webpack_public_path__ + "static/hero-ee747ffedd7745ab05a8e35d02d388a8.png";